import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { AppError } from '@/core/errors/AppError';
import { GenerarLiquidacionSchema, TIPOS_LIQUIDACION, } from '@/data/dto/liquidacion';
import { useGenerarLiquidacion } from '@/data/hooks/useLiquidaciones';
import { useEmpleados, usePromotores } from '@/data/hooks/useCatalogos';
import { Button } from '@/shared/components/Button';
import { Field } from '@/shared/components/Field';
import { Input } from '@/shared/components/Input';
import { Select } from '@/shared/components/Select';
import { Textarea } from '@/shared/components/Textarea';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, } from '@/shared/components/Modal';
import { useToast } from '@/shared/components/Toast';
function primerDiaDelMes() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
function hoyISO() {
    return new Date().toISOString().slice(0, 10);
}
export function GenerarLiquidacionDialog({ open, onOpenChange, onGenerada }) {
    const toast = useToast();
    const generar = useGenerarLiquidacion();
    const { data: empleados } = useEmpleados();
    const { data: promotores } = usePromotores();
    const form = useForm({
        resolver: zodResolver(GenerarLiquidacionSchema),
        defaultValues: {
            tipo: 'INSTRUCTOR',
            personaId: '',
            rangoDesde: primerDiaDelMes(),
            rangoHasta: hoyISO(),
            observaciones: '',
        },
    });
    const tipo = form.watch('tipo');
    useEffect(() => {
        if (!open)
            return;
        form.reset({
            tipo: 'INSTRUCTOR',
            personaId: '',
            rangoDesde: primerDiaDelMes(),
            rangoHasta: hoyISO(),
            observaciones: '',
        });
    }, [open, form]);
    const onSubmit = form.handleSubmit((values) => {
        generar.mutate(values, {
            onSuccess: (liq) => {
                toast.exito('Liquidación generada', `Código ${liq.codigo}`);
                onOpenChange(false);
                onGenerada?.(liq.id);
            },
            onError: (err) => {
                if (err instanceof AppError && err.errores) {
                    for (const e of err.errores) {
                        form.setError(e.campo, { message: e.mensaje });
                    }
                    return;
                }
                toast.error(err instanceof AppError ? err.mensaje : 'No pudimos generar.');
            },
        });
    });
    const errors = form.formState.errors;
    const personas = tipo === 'INSTRUCTOR' ? empleados : promotores;
    return (_jsx(Modal, { open: open, onOpenChange: onOpenChange, children: _jsxs(ModalContent, { size: "md", children: [_jsx(ModalHeader, { titulo: "Generar liquidaci\u00F3n", descripcion: "Se calcula en base a clases dictadas (instructor) o reservas pagas (promotor) dentro del per\u00EDodo." }), _jsxs("form", { onSubmit: onSubmit, noValidate: true, children: [_jsx(ModalBody, { children: _jsxs("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-2", children: [_jsx(Field, { label: "Tipo", error: errors.tipo?.message, required: true, children: _jsx(Select, { ...form.register('tipo', {
                                                onChange: () => form.setValue('personaId', ''),
                                            }), children: TIPOS_LIQUIDACION.map((t) => (_jsx("option", { value: t, children: t }, t))) }) }), _jsx(Field, { label: tipo === 'INSTRUCTOR' ? 'Instructor' : 'Promotor', error: errors.personaId?.message, required: true, children: _jsxs(Select, { ...form.register('personaId'), children: [_jsx("option", { value: "", children: "Seleccion\u00E1\u2026" }), personas?.map((p) => (_jsx("option", { value: p.id, children: 'apellido' in p && p.apellido
                                                        ? `${p.nombre} ${p.apellido}`
                                                        : p.nombre }, p.id)))] }) }), _jsx(Field, { label: "Desde", error: errors.rangoDesde?.message, required: true, children: _jsx(Input, { type: "date", ...form.register('rangoDesde') }) }), _jsx(Field, { label: "Hasta", error: errors.rangoHasta?.message, required: true, children: _jsx(Input, { type: "date", ...form.register('rangoHasta') }) }), _jsx(Field, { label: "Observaciones", error: errors.observaciones?.message, className: "sm:col-span-2", children: _jsx(Textarea, { rows: 2, ...form.register('observaciones') }) })] }) }), _jsxs(ModalFooter, { children: [_jsx(Button, { type: "button", variant: "secondary", onClick: () => onOpenChange(false), disabled: generar.isPending, children: "Cancelar" }), _jsx(Button, { type: "submit", cargando: generar.isPending, children: "Generar" })] })] })] }) }));
}
